import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ArrowDownIconComponent, NoImageIconComponent } from '@itero/ui-toolkit-angular/icons';
import { RxBannerDismissibleComponent } from '@shared/components/rx-banner-dismissible/rx-banner-dismissible.component';

@Component({
	selector: 'rx-intuitive-missing-attachments-banner',
	templateUrl: './rx-intuitive-missing-attachments-banner.component.html',
	styleUrls: ['./rx-intuitive-missing-attachments-banner.component.scss'],
	standalone: true,
	imports: [TranslateModule, ArrowDownIconComponent, NoImageIconComponent, RxBannerDismissibleComponent]
})
export class RxIntuitiveMissingAttachmentsBannerComponent {
	@Output() dismissed = new EventEmitter<void>();
	
	scrollToAttachments(event: Event): void {
		const attachmentsSection = document.getElementById('attachments-section');

		if (!attachmentsSection) {
			return;
		}

		event.preventDefault();
		attachmentsSection.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
	}
}
